import createIcon from '../../createIcon';

/**
 * @component @name NotificationsNone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMjEuNzVDMTMuMSAyMS43NSAxNCAyMC44NSAxNCAxOS43NUgxMEMxMCAyMC44NSAxMC45IDIxLjc1IDEyIDIxLjc1Wk0xOCAxNS43NVYxMC43NUMxOCA3LjY4IDE2LjM3IDUuMTEgMTMuNSA0LjQzVjMuNzVDMTMuNSAyLjkyIDEyLjgzIDIuMjUgMTIgMi4yNUMxMS4xNyAyLjI1IDEwLjUgMi45MiAxMC41IDMuNzVWNC40M0M3LjY0IDUuMTEgNiA3LjY3IDYgMTAuNzVWMTUuNzVMNCAxNy43NVYxOC43NUgyMFYxNy43NUwxOCAxNS43NVpNMTYgMTYuNzVIOFYxMC43NUM4IDguMjcgOS41MSA2LjI1IDEyIDYuMjVDMTQuNDkgNi4yNSAxNiA4LjI3IDE2IDEwLjc1VjE2Ljc1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NotificationsNone = createIcon('NotificationsNone', [
  [
    'path',
    {
      d: 'M12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.9 21.75 12 21.75ZM18 15.75V10.75C18 7.68 16.37 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.64 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75ZM16 16.75H8V10.75C8 8.27 9.51 6.25 12 6.25C14.49 6.25 16 8.27 16 10.75V16.75Z',
      key: '73wokn',
    },
  ],
]);

export default NotificationsNone;
